import React, { useEffect, useState } from "react";
import { Layout } from "../components";
import request from "../utils/request";
import useStudentForm from "../components/useStudentForm";
import { Center } from "@chakra-ui/layout";
import { Spinner } from "@chakra-ui/spinner";

const Student = (props) => {
  const { id } = props.match.params;
  const [studentData, updateData] = useState({});

  useEffect(() => {
    request
      .get({ from: `/student/${id}`, useToken: true })
      .then(({ data }) => {
        const studentData = {
          id: data["student_id"],
          firstName: data["first_name"],
          lastName: data["last_name"],
          gender: data["gender"],
          medicalCondition: data["medical_condition"],
          dob: data["dob"],
          profile: data["profile_photo"] || "",
          isPrevious: data["is_previous_student"] ? "true" : "false",
          islamicGradePrev: data["islamic_studies_grade_prev_year"],
          iqraGradePrev: data["iqra_grade_prev_year"],
          fatherName: data["father_name"],
          fatherEmail: data["father_email"],
          fatherContact: data["father_contact_number"],
          motherName: data["mother_name"],
          motherEmail: data["mother_email"],
          motherContact: data["mother_contact_number"],
          corresspondence: data["preferred_contact_for_correspondence"],
          corrEmail: data["email_for_correspondence"],
          homeAddress: data["home_address"],
          ambulanceCover: data["ambulance_cover"] ? "true" : "false",
          ambulanceMembershipNumber: data["ambulance_membership_number"],
          refereeName: data["referee_name"],
          refereePhone: data["referee_phone_number"],
          refereeEmail: data["referee_email_address"],
          enrollmentYear: data["enrolment_for_year"],
          academicYear: data["academic_year"] || "2026",
          fees_paid: data["fess_paid"],
          current_record: data["current_record"],
          status: data["status"],
          active_record: ["active_record"],
        };

        updateData(studentData);
      })
      .catch(() => {});
  }, [id]);

  return (
    <Layout>
      {Object.keys(studentData).length === 0 ? (
        <NoData />
      ) : (
        <DataForm data={studentData} />
      )}
    </Layout>
  );
};

const NoData = () => {
  return (
    <Center h="100vh">
      {" "}
      <Spinner size="lg"></Spinner>
    </Center>
  );
};

const DataForm = ({ data }) => {
  const [Form] = useStudentForm({ formData: data, isReadOnly: true });
  return <>{Form}</>;
};
export default Student;
